import { Navigate, RouteObject } from "react-router-dom";
import LoginPage from "../pages/LoginPage/LoginPage";
import HomePage from "../pages/SpareParts/HomePage/HomePage";
import OfferOrder from "../pages/SpareParts/OfferOrder/OfferOrder";
import { defaultBrand, defaultContext } from "./defaultSettings";
import InstalledBasePage from "../pages/SpareParts/InstalledBasePage/InstalledBasePage";
import AuthenticationCallBack from "../../explorer/components/Authentication/AuthenticationCallback";
import BasketPage from "../pages/BasketPage/BasketPage";
import SearchPartsPage from "../pages/SpareParts/SearchPartsPage/SearchPartsPage";
import Redirect from "../../explorer/components/Redirect/Redirect";
import StyleGuide from "../pages/StyleGuide/StyleGuide";
import MachinePage from "../pages/SpareParts/MachinePage/MachinePage";
import MachineMorePage from "../pages/SpareParts/MachineMorePage/MachineMorePage";
import PartDetailsPage from "../components/PartDetails/PartDetails/PartDetails";
import { ContainerErrorStyled, Text } from "./appRoute.style";

export const appRoutes: RouteObject[] = [
  // URL deve essere composto da /:brand/home
  {
    path: "/",
    // element: <Redirect to={defaultContext + "/" + defaultBrand} />,
    element: <Redirect to={defaultContext} />,
  },
  {
    path: "/styleguide/*",
    id: "styleguide",
    element: <StyleGuide />,
  },
  {
    path: "spareparts",
    children: [
      {
        path: "",
        id: "homePage",
        // element: <Redirect to={defaultBrand} />,
        element: <HomePage />,
      },
      {
        path: ":brand",
        id: "brand",
        children: [
          {
            path: "",
            id: "spareparts-homepage",
            element: <HomePage />,
          },
          {
            path: "site/:customerSiteCode/installedbase",
            id: "spareparts-installedbase",
            element: <InstalledBasePage />,
          },
          {
            path: "site/:customerSiteCode/machine/:machineId/*",
            id: "spareparts-machine",
            element: <MachinePage />,
          },
          {
            path: "partdetails/:partCode/*",
            id: "spareparts-machine",
            element: <PartDetailsPage />,
          },
          {
            path: "site/:customerSiteCode/machine/:machineId/more/:tabIndex",
            id: "spareparts-machine-more",
            element: <MachineMorePage />,
          },
          {
            path: "basket",
            id: "basket",
            element: <BasketPage />,
          },
          {
            path: "offerOrderHistory",
            id: "system-offerOrderHistory",
            element: <OfferOrder />,
          },
          {
            path: "search/:codeSearched",
            id: "search",
            element: <SearchPartsPage />,
          },
        ],
      },
    ],
    errorElement: <ErrorPage />,
  },
  {
    path: "login",
    id: "loginPage",
    element: <LoginPage />,
  },
  {
    path: "/authentication/callback",
    id: "authenticationCallback",
    element: <AuthenticationCallBack />,
  },
  {
    path: "*",
    id: "error",
    element: <ErrorPage />,
  },
];

export default function ErrorPage() {
  return (
    <ContainerErrorStyled id="error-page">
      <Text variant="h2">Oops!</Text>
      <p>Sorry, Page not found.</p>
    </ContainerErrorStyled>
  );
}